// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  configFile: 'assets/config.json',

  //apiUrl: 'https://narrator-back.test/api/back',
  firebaseConfig: {
    apiKey: "AIzaSyDBPA8pTUq01OfsZwXymsmn3lQTsZrtzjY",
    authDomain: "narratheque.firebaseapp.com",
    projectId: "narratheque",
    storageBucket: "narratheque.firebasestorage.app",
    messagingSenderId: "715983646421",
    appId: "1:715983646421:web:84a404adbaa77db3a8fc5c",
    measurementId: "G-ZJRYF46F93"
  },
  sentryDsn: 'https://3dbf744356aa6a0bdbe26344da091d62@o4509071542321152.ingest.de.sentry.io/4509083581612112'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
